import axios from "axios";

const service = axios.create({
  timeout: 5000
});

service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      let res = response.data;
      if (res.code !== undefined) {
        if (res.code === 200) {
          return res.data;
        }
        return Promise.reject(res);
      }
      return res;
    } else if (response.status === 500) {
      return Promise.reject(response);
    } else {
      alert("error");
      return Promise.reject("error");
    }
  },
  error => {
    console.log(error);
    // alert("timeout");
    return Promise.reject(error);
  }
);

export default service;
